<template>
    <div class="p-grid p-fluid p-justify-center p-nogutter">
        <div v-if="christmasTime" class="p-col-12 p-text-center p-mb-3" style="height:80px; line-height: 80px">
            <img src="https://th.bing.com/th/id/R.2c60f897acab865294236dc24cd7c2c0?rik=1KhK3HbXei8E7g&riu=http%3a%2f%2fwww.clker.com%2fcliparts%2f2%2fB%2fD%2ft%2ft%2fW%2fchristmas-bells-rotated-th.png&ehk=ZJObTe0HAB%2bTUPvjKWipF4Z%2bZ%2fLD750LMoRf14X30es%3d&risl=&pid=ImgRaw&r=0" alt="" style="height:50%"/>
            <strong> {{ $t('closedForChristmas') }} </strong>
            <img src="https://th.bing.com/th/id/R.2c60f897acab865294236dc24cd7c2c0?rik=1KhK3HbXei8E7g&riu=http%3a%2f%2fwww.clker.com%2fcliparts%2f2%2fB%2fD%2ft%2ft%2fW%2fchristmas-bells-rotated-th.png&ehk=ZJObTe0HAB%2bTUPvjKWipF4Z%2bZ%2fLD750LMoRf14X30es%3d&risl=&pid=ImgRaw&r=0" alt="" style="height:50%"/>
        </div>
        <div v-else-if="false" class="p-col-12 p-text-center p-mb-3" style="height:80px; line-height: 80px">
            <img src="https://external-content.duckduckgo.com/iu/?u=http%3A%2F%2Fwww.clker.com%2Fcliparts%2F9%2F7%2F3%2F7%2F13683075091168459893sun-icon.png&f=1&nofb=1" alt="" style="height:50%"/>
            <strong>{{ $t('closedForSummer') }}</strong>
        </div>
        <main class="p-col-11 p-xl-10" style="margin: 5em 0;">
            <section class="p-grid p-fluid p-justify-center" style="background-color: white; padding: 3em 1em;">
                <article class="p-col-12 p-lg-6 border-lg-right">
                    <div>
                        <div class="text-center">
                            <img src="assets/images/puzzle.png" alt="image" class="img-fluid">
                        </div>
                        <div class="p-3">
                            <p class="font-weight-bold">
                                Måske Danmarks bedste miljø- og arbejdsmiljøstyringssystem: m-navigator
                            </p>
                            <p>
                                I m-navigator kan du:
                            </p>
                            <ul>
                                <li>arbejde med ledelsesstandarderne ISO14001, 45001 og 50001.</li>
                                <li>overvåge dit energiforbrug, din CO<sub>2</sub> emission, dit
                                    vandforbrug og spildevandsproduktion.
                                </li>
                                <li>styre dine kemikalier. Vi sørger for at vedligeholde
                                    kemidokumentationen.
                                </li>
                                <li>styre din affaldsproduktion pr. EAK-kode.</li>
                                <li>styre andre væsentlige miljø- og arbejdsmiljøforhold.</li>
                                <li>udarbejde brancheorienteret Arbejdspladsvurdering (APV) og
                                    Miljøvurdering (MV).
                                </li>
                                <li>kontrollere om du overholder miljø- og arbejdsmiljølovgivningen
                                    med adgang til relevant lovgivning.
                                </li>
                                <li>styre lovpligtige eftersyn med interaktiv kontrolbog.</li>
                                <li>få den nødvendige feed-back, der opsummerer udviklingen.</li>
                                <li>blive opdateret på lovgivningsændringer.</li>
                                <li>håndtere al den dokumentation som standarderne kræver.</li>
                            </ul>
                            <p>Vi leverer ikke bare systematikken, men også kompetent rådgivning indenfor arbejdsmiljø-
                                og miljøområderne.</p>
                            <p>Så kontakt os blot, hvis du har en konkret sag du bokser med eller hvis du vil vide
                                mere!</p>
                        </div>
                    </div>
                </article>
                <div class="p-col-12 p-lg-6">
                    <div class="p-grid p-fluid p-justify-center">
                        <div class="p-col-12 p-sm-10 p-lg-8">
                            <Header></Header>
                            <Login></Login>
                        </div>
                    </div>
                </div>
            </section>
        </main>

        <Footer></Footer>

        <svg viewBox="0 0 100 100" preserveAspectRatio="none slice"
            :style="{minWidth: '320px', position: 'absolute', top: christmasTime ? '80px': 0, left: 0, width: '100%', height: '800px', zIndex: '-1'}"
             xmlns="http://www.w3.org/2000/svg">
            <defs>
                <linearGradient id="grad">
                    <stop offset="0" stop-color="rgb(137,197,192)"></stop>
                    <stop offset="1" stop-color="rgb(211,233,232)"></stop>
                </linearGradient>
            </defs>

            <rect width="100" height="55" style="fill: url(#grad)"></rect>

            <polygon points="0,55 100,55 0,90" style="fill: url(#grad)"></polygon>
        </svg>
    </div>
</template>

<style scoped>
* {
    color: rgb(88, 88, 88);
}

@media (min-width: 1024px) {
    .border-lg-right {
        border-right: 1px solid rgb(222, 226, 230);
    }
}
</style>

<style lang="scss">
@import '~bootstrap/scss/bootstrap';
</style>

<script>
import Header from "@/components/Shared/Header";
import Footer from "@/components/Shared/Footer";
import Login from "@/components/Users/Login";

export default {
    name: 'home',
    components: {
        Header,
        Login,
        Footer
    },
    computed: {
        christmasTime() {
            const from = new Date("2021-12-22");
            const to = new Date("2022-01-04");
            const now = new Date();
            return from <= now && now < to;
        }
    }
}
</script>

<i18n lang="yaml" locale="en">
closedForSummer: Intersolia Denmark office will be closed for summer holiday throughout weeks 28 & 29
closedForChristmas: Merry Christmas and a Happy New Year! We are closed from Dec 24 to Jan 3
</i18n>

<i18n lang="yaml" locale="dk">
closedForSummer: Vi holder sommerferie i uge 28-29
closedForChristmas: Glædelig Jul og Godt Nytår, Vi holder lukket fra 24. December til 3. Januar
</i18n>